/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Notice API Specification
 * OpenAPI spec version: 0.0.8
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  ApiResponseNoticeDetailView,
  ApiResponseNoticeInfoResponse,
  ApiResponseNoticeOverView,
  ApiResponsePostPopupInfoResponse,
  GetV8NoticeListParams,
  IdInfo,
  NoticeInfoRequestBody,
  ResultResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 공지사항 삭제 API
 */
export const postV8NoticeDelete = (
  idInfo: MaybeRef<IdInfo[]>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  idInfo = unref(idInfo);

  return customAxiosInstance<ResultResponse>(
    {
      url: `/api/v8/notice/delete`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: idInfo,
      signal,
    },
    options,
  );
};

export const getPostV8NoticeDeleteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8NoticeDelete>>,
    TError,
    { data: BodyType<IdInfo[]> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8NoticeDelete>>,
  TError,
  { data: BodyType<IdInfo[]> },
  TContext
> => {
  const mutationKey = ['postV8NoticeDelete'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8NoticeDelete>>,
    { data: BodyType<IdInfo[]> }
  > = (props) => {
    const { data } = props ?? {};

    return postV8NoticeDelete(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8NoticeDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8NoticeDelete>>
>;
export type PostV8NoticeDeleteMutationBody = BodyType<IdInfo[]>;
export type PostV8NoticeDeleteMutationError = ErrorType<unknown>;

/**
 * @summary 공지사항 삭제 API
 */
export const usePostV8NoticeDelete = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8NoticeDelete>>,
      TError,
      { data: BodyType<IdInfo[]> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8NoticeDelete>>,
  TError,
  { data: BodyType<IdInfo[]> },
  TContext
> => {
  const mutationOptions = getPostV8NoticeDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary (관리자, 홈뷰) 공지사항 목록 반환 API
 */
export const getV8NoticeList = (
  params?: MaybeRef<GetV8NoticeListParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseNoticeOverView>(
    { url: `/api/v8/notice/list`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV8NoticeListQueryKey = (params?: MaybeRef<GetV8NoticeListParams>) => {
  return ['api', 'v8', 'notice', 'list', ...(params ? [params] : [])] as const;
};

export const getGetV8NoticeListQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8NoticeList>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV8NoticeListParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV8NoticeList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8NoticeListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8NoticeList>>> = ({ signal }) =>
    getV8NoticeList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8NoticeList>>,
    TError,
    TData
  >;
};

export type GetV8NoticeListQueryResult = NonNullable<Awaited<ReturnType<typeof getV8NoticeList>>>;
export type GetV8NoticeListQueryError = ErrorType<unknown>;

/**
 * @summary (관리자, 홈뷰) 공지사항 목록 반환 API
 */

export function useGetV8NoticeList<
  TData = Awaited<ReturnType<typeof getV8NoticeList>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV8NoticeListParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV8NoticeList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8NoticeListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary (팝업) 공지사항 목록 반환 API - 게시시작일 이후 & 팝업 기간에 포함되는 공지사항
 */
export const getV8NoticePopup = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<ApiResponseNoticeOverView>(
    { url: `/api/v8/notice/popup`, method: 'GET', signal },
    options,
  );
};

export const getGetV8NoticePopupQueryKey = () => {
  return ['api', 'v8', 'notice', 'popup'] as const;
};

export const getGetV8NoticePopupQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8NoticePopup>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV8NoticePopup>>, TError, TData>>;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8NoticePopupQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8NoticePopup>>> = ({ signal }) =>
    getV8NoticePopup(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8NoticePopup>>,
    TError,
    TData
  >;
};

export type GetV8NoticePopupQueryResult = NonNullable<Awaited<ReturnType<typeof getV8NoticePopup>>>;
export type GetV8NoticePopupQueryError = ErrorType<unknown>;

/**
 * @summary (팝업) 공지사항 목록 반환 API - 게시시작일 이후 & 팝업 기간에 포함되는 공지사항
 */

export function useGetV8NoticePopup<
  TData = Awaited<ReturnType<typeof getV8NoticePopup>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV8NoticePopup>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8NoticePopupQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary (팝업) 공지사항 목록 반환 API (로그인 화면)
 */
export const getV8NoticePopupCheck = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<ApiResponsePostPopupInfoResponse>(
    { url: `/api/v8/notice/popup-check`, method: 'GET', signal },
    options,
  );
};

export const getGetV8NoticePopupCheckQueryKey = () => {
  return ['api', 'v8', 'notice', 'popup-check'] as const;
};

export const getGetV8NoticePopupCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8NoticePopupCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getV8NoticePopupCheck>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8NoticePopupCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8NoticePopupCheck>>> = ({ signal }) =>
    getV8NoticePopupCheck(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8NoticePopupCheck>>,
    TError,
    TData
  >;
};

export type GetV8NoticePopupCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8NoticePopupCheck>>
>;
export type GetV8NoticePopupCheckQueryError = ErrorType<unknown>;

/**
 * @summary (팝업) 공지사항 목록 반환 API (로그인 화면)
 */

export function useGetV8NoticePopupCheck<
  TData = Awaited<ReturnType<typeof getV8NoticePopupCheck>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8NoticePopupCheck>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8NoticePopupCheckQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 공지사항 저장 및 임시저장 API
 */
export const postV8NoticeSave = (
  noticeInfoRequestBody: MaybeRef<NoticeInfoRequestBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  noticeInfoRequestBody = unref(noticeInfoRequestBody);

  return customAxiosInstance<ResultResponse>(
    {
      url: `/api/v8/notice/save`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: noticeInfoRequestBody,
      signal,
    },
    options,
  );
};

export const getPostV8NoticeSaveMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8NoticeSave>>,
    TError,
    { data: BodyType<NoticeInfoRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8NoticeSave>>,
  TError,
  { data: BodyType<NoticeInfoRequestBody> },
  TContext
> => {
  const mutationKey = ['postV8NoticeSave'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8NoticeSave>>,
    { data: BodyType<NoticeInfoRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV8NoticeSave(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8NoticeSaveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8NoticeSave>>
>;
export type PostV8NoticeSaveMutationBody = BodyType<NoticeInfoRequestBody>;
export type PostV8NoticeSaveMutationError = ErrorType<unknown>;

/**
 * @summary 공지사항 저장 및 임시저장 API
 */
export const usePostV8NoticeSave = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8NoticeSave>>,
      TError,
      { data: BodyType<NoticeInfoRequestBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8NoticeSave>>,
  TError,
  { data: BodyType<NoticeInfoRequestBody> },
  TContext
> => {
  const mutationOptions = getPostV8NoticeSaveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 공지사항 편집을 눌렀을 때 기존 공지사항 정보를 반환하는 API
 */
export const getV8NoticeByNoticeId = (
  noticeId: MaybeRef<number>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  noticeId = unref(noticeId);

  return customAxiosInstance<ApiResponseNoticeInfoResponse>(
    { url: `/api/v8/notice/${noticeId}`, method: 'GET', signal },
    options,
  );
};

export const getGetV8NoticeByNoticeIdQueryKey = (noticeId?: MaybeRef<number>) => {
  return ['api', 'v8', 'notice', noticeId] as const;
};

export const getGetV8NoticeByNoticeIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8NoticeByNoticeId>>,
  TError = ErrorType<unknown>,
>(
  noticeId: MaybeRef<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8NoticeByNoticeId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8NoticeByNoticeIdQueryKey(noticeId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8NoticeByNoticeId>>> = ({ signal }) =>
    getV8NoticeByNoticeId(noticeId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(noticeId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV8NoticeByNoticeId>>, TError, TData>;
};

export type GetV8NoticeByNoticeIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8NoticeByNoticeId>>
>;
export type GetV8NoticeByNoticeIdQueryError = ErrorType<unknown>;

/**
 * @summary 공지사항 편집을 눌렀을 때 기존 공지사항 정보를 반환하는 API
 */

export function useGetV8NoticeByNoticeId<
  TData = Awaited<ReturnType<typeof getV8NoticeByNoticeId>>,
  TError = ErrorType<unknown>,
>(
  noticeId: MaybeRef<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8NoticeByNoticeId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8NoticeByNoticeIdQueryOptions(noticeId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 공지사항 클릭 히스토리 API
 */
export const postV8NoticeClickedByNoticeId = (
  noticeId: MaybeRef<number>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  noticeId = unref(noticeId);

  return customAxiosInstance<ResultResponse>(
    { url: `/api/v8/notice/${noticeId}/clicked`, method: 'POST', signal },
    options,
  );
};

export const getPostV8NoticeClickedByNoticeIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8NoticeClickedByNoticeId>>,
    TError,
    { noticeId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8NoticeClickedByNoticeId>>,
  TError,
  { noticeId: number },
  TContext
> => {
  const mutationKey = ['postV8NoticeClickedByNoticeId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8NoticeClickedByNoticeId>>,
    { noticeId: number }
  > = (props) => {
    const { noticeId } = props ?? {};

    return postV8NoticeClickedByNoticeId(noticeId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8NoticeClickedByNoticeIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8NoticeClickedByNoticeId>>
>;

export type PostV8NoticeClickedByNoticeIdMutationError = ErrorType<unknown>;

/**
 * @summary 공지사항 클릭 히스토리 API
 */
export const usePostV8NoticeClickedByNoticeId = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8NoticeClickedByNoticeId>>,
      TError,
      { noticeId: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8NoticeClickedByNoticeId>>,
  TError,
  { noticeId: number },
  TContext
> => {
  const mutationOptions = getPostV8NoticeClickedByNoticeIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 공지사항 상세 조회 API
 */
export const getV8NoticeDetailByNoticeId = (
  noticeId: MaybeRef<number>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  noticeId = unref(noticeId);

  return customAxiosInstance<ApiResponseNoticeDetailView>(
    { url: `/api/v8/notice/${noticeId}/detail`, method: 'GET', signal },
    options,
  );
};

export const getGetV8NoticeDetailByNoticeIdQueryKey = (noticeId?: MaybeRef<number>) => {
  return ['api', 'v8', 'notice', noticeId, 'detail'] as const;
};

export const getGetV8NoticeDetailByNoticeIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8NoticeDetailByNoticeId>>,
  TError = ErrorType<unknown>,
>(
  noticeId: MaybeRef<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8NoticeDetailByNoticeId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8NoticeDetailByNoticeIdQueryKey(noticeId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8NoticeDetailByNoticeId>>> = ({
    signal,
  }) => getV8NoticeDetailByNoticeId(noticeId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(noticeId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV8NoticeDetailByNoticeId>>, TError, TData>;
};

export type GetV8NoticeDetailByNoticeIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8NoticeDetailByNoticeId>>
>;
export type GetV8NoticeDetailByNoticeIdQueryError = ErrorType<unknown>;

/**
 * @summary 공지사항 상세 조회 API
 */

export function useGetV8NoticeDetailByNoticeId<
  TData = Awaited<ReturnType<typeof getV8NoticeDetailByNoticeId>>,
  TError = ErrorType<unknown>,
>(
  noticeId: MaybeRef<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8NoticeDetailByNoticeId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8NoticeDetailByNoticeIdQueryOptions(noticeId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 공지사항 테스트 이메일 발송 API
 */
export const postV8NoticeTestEmailByNoticeId = (
  noticeId: MaybeRef<number>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  noticeId = unref(noticeId);

  return customAxiosInstance<ResultResponse>(
    { url: `/api/v8/notice/${noticeId}/test-email`, method: 'POST', signal },
    options,
  );
};

export const getPostV8NoticeTestEmailByNoticeIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8NoticeTestEmailByNoticeId>>,
    TError,
    { noticeId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8NoticeTestEmailByNoticeId>>,
  TError,
  { noticeId: number },
  TContext
> => {
  const mutationKey = ['postV8NoticeTestEmailByNoticeId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8NoticeTestEmailByNoticeId>>,
    { noticeId: number }
  > = (props) => {
    const { noticeId } = props ?? {};

    return postV8NoticeTestEmailByNoticeId(noticeId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8NoticeTestEmailByNoticeIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8NoticeTestEmailByNoticeId>>
>;

export type PostV8NoticeTestEmailByNoticeIdMutationError = ErrorType<unknown>;

/**
 * @summary 공지사항 테스트 이메일 발송 API
 */
export const usePostV8NoticeTestEmailByNoticeId = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8NoticeTestEmailByNoticeId>>,
      TError,
      { noticeId: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8NoticeTestEmailByNoticeId>>,
  TError,
  { noticeId: number },
  TContext
> => {
  const mutationOptions = getPostV8NoticeTestEmailByNoticeIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 공지사항 수정 API
 */
export const patchV8NoticeUpdateByNoticeId = (
  noticeId: MaybeRef<number>,
  noticeInfoRequestBody: MaybeRef<NoticeInfoRequestBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  noticeId = unref(noticeId);
  noticeInfoRequestBody = unref(noticeInfoRequestBody);

  return customAxiosInstance<ResultResponse>(
    {
      url: `/api/v8/notice/${noticeId}/update`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: noticeInfoRequestBody,
    },
    options,
  );
};

export const getPatchV8NoticeUpdateByNoticeIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV8NoticeUpdateByNoticeId>>,
    TError,
    { noticeId: number; data: BodyType<NoticeInfoRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV8NoticeUpdateByNoticeId>>,
  TError,
  { noticeId: number; data: BodyType<NoticeInfoRequestBody> },
  TContext
> => {
  const mutationKey = ['patchV8NoticeUpdateByNoticeId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV8NoticeUpdateByNoticeId>>,
    { noticeId: number; data: BodyType<NoticeInfoRequestBody> }
  > = (props) => {
    const { noticeId, data } = props ?? {};

    return patchV8NoticeUpdateByNoticeId(noticeId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV8NoticeUpdateByNoticeIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV8NoticeUpdateByNoticeId>>
>;
export type PatchV8NoticeUpdateByNoticeIdMutationBody = BodyType<NoticeInfoRequestBody>;
export type PatchV8NoticeUpdateByNoticeIdMutationError = ErrorType<unknown>;

/**
 * @summary 공지사항 수정 API
 */
export const usePatchV8NoticeUpdateByNoticeId = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV8NoticeUpdateByNoticeId>>,
      TError,
      { noticeId: number; data: BodyType<NoticeInfoRequestBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV8NoticeUpdateByNoticeId>>,
  TError,
  { noticeId: number; data: BodyType<NoticeInfoRequestBody> },
  TContext
> => {
  const mutationOptions = getPatchV8NoticeUpdateByNoticeIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
